import _isString from 'lodash-es/isString';
import _filter from 'lodash-es/filter';
import _includes from 'lodash-es/includes';
import _sortBy from 'lodash-es/sortBy';
import _toUpper from 'lodash-es/toUpper';
import _map from 'lodash-es/map';
import _set from 'lodash-es/set';
import { Component, EventEmitter, ViewChild, Input, OnInit, AfterViewInit } from '@angular/core';
import { GenericField, IGenericField } from '../generic-field';
import { SearchService } from './search.service';
import { FormBuilderService } from "../../../../service/formBuilder/formBuilder.service";
import { AutoCompleteFb } from 'libraries/module/formbuilder/fields/autocomplete-legacy/autoComplete-fb.component';

/**
 * @deprecated use autocomplete instead
 */
@Component({
    selector: 'autocomplete-static-field',
    templateUrl: './autocomplete-static-field.html',
    styleUrls: [],
})
export class AutoCompleteStaticFieldComponent extends GenericField implements IGenericField, OnInit, AfterViewInit {
    public focusEmit: EventEmitter<boolean> = new EventEmitter();

    @Input()
    public strict: boolean;

    @Input()
    public itemLabel: any;


    public suggestions: any[] = [];

    @ViewChild('fieldElement')
    private fieldElement: AutoCompleteFb;

    constructor(private searchService: SearchService, private formBuilderService: FormBuilderService) {
        super();
    }

    public ngOnInit(): void {
        if (!this.options || this.options.length === 0) {
            this.options = [];
        }

        if (this.parsingValueLocation && _isString(this.parsingValueLocation) && this.parsingValueLocation !== '') {
            this.parseInput();
        }
        this.group.get(this.controlName).valueChanges.subscribe(
            (data) => {
                if (_isString(data) && data.length >= 2) {
                    this.search({query: data});
                }
            }
        );

    }

    public ngAfterViewInit(): void {
        this.subscription = this.formBuilderService
            .focusEvent
            .subscribe(
                (_focusName: any) => {
                    if (this.focusName && _focusName === this.focusName) {
                        this.focusEmit.emit(true);
                    }
                });
    }

    public onBlur($event): void {
        super.onBlur($event);
    }

    public setFocus(): void {
        const control = this.group.get(this.controlName);

        const previouslyDirty = control.dirty;

        this.fieldElement.setFocus();

        if (!previouslyDirty) {
            this.group.get(this.controlName).markAsPristine({onlySelf: false});
        }
    }

    private search(event): void {
        this.suggestions = _filter(this.options, (option: any): boolean => _includes(_toUpper(option.label), _toUpper(event.query)));
    }

    private parseInput(): void {

        if (this.options.length && this.options[0].name) {

            const parsedData = this.options[0].code ?
                _sortBy(this.options, ['code', 'name']) :
                _sortBy(this.options, 'name');

            _map(parsedData, (item: any) => {
                if (item.id && item.code) {
                    _set(item, 'label', item.name + " (" + _toUpper(item.code) + ")");
                } else {
                    _set(item, 'label', item.name);
                }
                _set(item, 'value', item[this.parsingValueLocation]);
            });

            this.options = parsedData;
        }
    }
}
